
//import './libs/detectizr/modernizr-custom';
//import './libs/detectizr/detectizr.min';
//import '@iconfu/svg-inject/dist/svg-inject';

//import $ from 'jquery';
//window.$ = $;

import Main from './src/main';

$(document).ready( ()=>{

	const app = new Main({
		is_ajax 			: true,
		is_locomotive 		: false,
		is_locomotive_touch	: false,
		$scroll_el			: '#smooth-scroll',
		debug				: false,
		slide_transition	: false,
		time_fade_in 		: 0.8,
		time_fade_out 		: 0.17,
		project_name		: 'Cristina Grajales Gallery',
		GA_MEASUREMENT_ID 	: 'G-8MY18FBDGS',
		redirects			: [
		]
		
	});

	app.init()
	
});